import React, { useState, useContext, useEffect, useRef } from "react";
import FuncionesContext from "../../../context/FuncionesContext";
//import ListadoContext from "../../context/ListadoContext";

const SiNoEditable = ({
  data,
  cab,
  campokey,
  key,
  indiceData,
  id_elemento,
  updateState,
}) => {
  const { superSubmit } = useContext(FuncionesContext);
  // const { celdas } = useContext(ListadoContext);

  const [value, setValue] = useState(data[campokey]);
  const [lastValue, setLastvalue] = useState(data[campokey]);
  const [update_id, setUpdate_id] = useState(data[cab.update_id_alias]);

  const id_a = cab.id_a;
  // const celdaref = useRef(celdas[id_a + data._key]);

  const handleCancelar = () => {
    setValue(data[campokey]);
    setLastvalue(data[campokey]);
  };

  const handleChange = async (e) => {
    const valor = e.target.value === "s" ? "s" : "n";

    if (valor === null || lastValue?.toString() === valor.toString().trim())
      return;

    const { id_a } = cab;

    setValue(valor);

    superSubmit({ valor, id_a, update_id, handleCancelar, cab, data })
      .then((result) => {
        setLastvalue(valor);

        updateState(campokey, valor);
        if (!update_id) {
          updateState(cab.update_id_alias, result.data.registro.id);
        }
        return result;
      })
      .catch((err) => {
        console.log("Cancelado ", err);
      });
  };

  useEffect(() => {
    const updateInertalAttributes = () => {
      setValue(data[campokey]);
      setUpdate_id(data[cab.update_id_alias]);
    };

    document.addEventListener(cab.id_a, updateInertalAttributes);

    return document.removeEventListener(cab.id_a, updateInertalAttributes);
  }, [cab.id_a, cab.update_id_alias, campokey, data]);

  if (cab.default && !value) {
    setValue(cab.default);
  }

  // useEffect(() => {
  //   // cambia valor al default cuando cambia el valor original del request (celda[id_a+data._key]).
  //   if (!celdaref.current) return;
  //   if (celdas[id_a + data._key] !== celdaref.current) {
  //     celdaref.current = celdas[id_a + data._key];

  //     updateState(campokey, cab.default);
  //   }
  // }, [celdas[id_a + data._key]]);

  return (
    <div
      id={id_elemento}
      key={key}
      className="tarjeta_grid_item_label_item"
      style={{ textAlign: cab.align ?? "center" }}
    >
      {cab.label ? (
        <div className="vista_label" style={{ fontWeight: "bold" }}>
          {cab.label}:
        </div>
      ) : (
        <></>
      )}

      <select
        onChange={handleChange}
        value={value === null ? "null" : value === "s" ? "s" : "n"}
        style={{ marginLeft: "5px" }}
        className={data[cab.className] ?? cab.className}
      >
        <option value="s" disabled={data[cab.update_id_alias] ? false : true}>
          SI
        </option>
        <option value="n" disabled={data[cab.update_id_alias] ? false : true}>
          NO
        </option>
        <option value="null" disabled></option>
      </select>
    </div>
  );
};

export default SiNoEditable;
